import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SERVER_API_URL } from 'app/app.constants';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class RoleRestService {
  roleList: Array<{id: number, name: string}> = []
  constructor(private http:HttpClient) { }

  getRoles() {
    return this.roleList = [
      {id: 1, name: 'Admin'},
      {id: 2, name: 'Users'}
    ]
  }
  getPostById(id)
  {
    return this.http.get(SERVER_API_URL + "api/post/" + id)
  }
  addPost(form:any): Observable<any>
  {
   return this.http.post(SERVER_API_URL+'api/post/store',form.value)
  }
}
